import DataGridBase from "Components/dataGridBase";
import styled from "styled-components";
export const SIZES = {
    FORM_CAPTION_HEIGHT: 25,
    MIN_FORM_HEIGHT: 290
};
export default {
    DataGridBase: styled(DataGridBase) `
    .with-role-form-caption-height {
      min-height: ${SIZES.FORM_CAPTION_HEIGHT}px;
    }
  `
};
